export const MARKETPLACE_FILTER = 'MARKETPLACE_FILTER';

export const MARKETPLACE_INDEX_REQUEST = 'MARKETPLACE_INDEX_REQUEST';
export const MARKETPLACE_INDEX_SUCCESS = 'MARKETPLACE_INDEX_SUCCESS';
export const MARKETPLACE_INDEX_FAILURE = 'MARKETPLACE_INDEX_FAILURE';
export const MARKETPLACE_INDEX = [MARKETPLACE_INDEX_REQUEST, MARKETPLACE_INDEX_SUCCESS, MARKETPLACE_INDEX_FAILURE];
